module.exports = __webpack_public_path__ + "img/12_klio_16.4085651d.jpg";